var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBlock2 = function SvgBlock2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 13.334C6.76901 13.334 5.63834 12.9107 4.73501 12.2087L12.2077 4.73598C12.9103 5.63865 13.333 6.76998 13.333 8.00065C13.333 10.9413 10.9403 13.334 7.99967 13.334ZM2.66634 8.00065C2.66634 5.05998 5.05901 2.66732 7.99967 2.66732C9.23034 2.66732 10.361 3.09065 11.2643 3.79265L3.79167 11.2653C3.08901 10.3627 2.66634 9.23132 2.66634 8.00065ZM7.99967 1.33398C4.32367 1.33398 1.33301 4.32465 1.33301 8.00065C1.33301 11.6767 4.32367 14.6673 7.99967 14.6673C11.6757 14.6673 14.6663 11.6767 14.6663 8.00065C14.6663 4.32465 11.6757 1.33398 7.99967 1.33398Z",
    fill: "currentColor"
  })));
};
export default SvgBlock2;